require('./index.less');



//////////////////
// WEBPACK FOOTER
// ./Frontend/src/views/contact/index.js
// module id = 0
// module chunks = 5